export const SESSION_HEADER = 'x-nvd-session';
export const DEFAULT_PROXY_PATH_PREFIX = '/apps/claims';
export const ROOT_ELEMENT_ID = 'nvd-claim-portal';
export const CONFIG_ELEMENT_ID = 'nvd-claim-portal-config';
/** The merchant editor: its own header, mount point and boot payload. */
export const EDITOR_HEADER = 'x-nvd-editor';
export const EDITOR_ROOT_ELEMENT_ID = 'nvd-claim-editor';
export const EDITOR_BOOT_ELEMENT_ID = 'nvd-claim-editor-boot';
export const MAX_UPLOADS_PER_CLAIM = 5;
export const ACCEPTED_UPLOAD_MIME = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'application/pdf'];
//# sourceMappingURL=constants.js.map